export function getFormatedTel (tel) {
    let outputed_tel = ''

    tel.split('').forEach( char => {
        if (char !== ' ' && char !== '(' && char !== ')' && char !== '-' && char !== '+') {
            outputed_tel += char
        }
    })

    return outputed_tel
}